<template>
    <section>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <div class="modal-card" style="width: 1080px">
                <header class="modal-card-head">
                    <p class="modal-card-title">Ampliar Plazo de Declaración de un/a Académico/a</p>
                    <button type="button" class="delete" @click="$emit('close')" />
                </header>
                <section class="modal-card-body">

                    <div v-if="isSelectedAcademic === false">
                        <form @submit.prevent="handleSubmit(filterAcademics)">
                            <div class="columns">
                                <div class="column">
                                    <b-field label="RUT">
                                        <ValidationProvider name="RUT" rules="integer|positive|min:7|max:8"
                                            v-slot="{ errors }">
                                            <b-input v-model="filter.rut" type="number" placeholder="Ej: 19986732" />
                                            <span class="validation-alert">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </b-field>
                                </div>

                                <div class="column is-2">
                                    <b-field label="DV">
                                        <ValidationProvider name="DV" rules="max:1|min:1" v-slot="{ errors }">
                                            <b-input v-model="filter.dv" placeholder="Ej: 6 o k" />
                                            <span class="validation-alert">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </b-field>
                                </div>

                                <div class="column">
                                    <b-field label="Unidad *">
                                        <ValidationProvider name="Unidad" rules="required" v-slot="{ errors }">
                                            <multiselect v-model="filter.unit_id" :options="units.map(unit => unit.id)"
                                                :custom-label="opt => units.find(x => x.id === opt).name"
                                                placeholder="Seleccione una Unidad"
                                                selectLabel="Presione para seleccionar" selectedLabel="Seleccionado"
                                                deselectLabel="Presione para deseleccionar" :allow-empty="false">
                                                <template v-slot:noOptions>
                                                    No existen datos
                                                </template>
                                                <span slot="noResult">
                                                    No se encontraron elementos.
                                                </span>
                                            </multiselect>
                                            <span class="validation-alert">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </b-field>
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column">
                                    <b-field label="Nombres">
                                        <ValidationProvider name="Nombre" rules="min:3|max:255" v-slot="{ errors }">
                                            <b-input v-model="filter.name" placeholder="Ej: Felipe" />
                                            <span class="validation-alert">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </b-field>
                                </div>

                                <div class="column">
                                    <b-field label="Primer Apellido">
                                        <ValidationProvider name="Primer Apellido" rules="min:3|max:255"
                                            v-slot="{ errors }">
                                            <b-input v-model="filter.last_name" placeholder="Ej: Solis" />
                                            <span class="validation-alert">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </b-field>
                                </div>

                                <div class="column">
                                    <b-field label="Segundo Apellido">
                                        <ValidationProvider name="Segundo Apellido" rules="min:3|max:255"
                                            v-slot="{ errors }">
                                            <b-input v-model="filter.second_surname" placeholder="Ej: Dominguez" />
                                            <span class="validation-alert">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </b-field>
                                </div>
                            </div>

                            <div class="columns">
                                <div class="column has-text-right">
                                    <b-button type="is-blue-color" label="Buscar Académico/a" icon-left="search"
                                        @click="activeFilter = true; filterAcademics()" />
                                </div>
                            </div>

                            <b-table v-if="activeFilter" :data="academics" paginated per-page=10
                                :pagination-simple=false pagination-position="bottom" aria-next-label="Siguiente"
                                aria-previous-label="Anterior" aria-page-label="Página"
                                aria-current-label="Página actual" striped checkable
                                :checked-rows.sync="academicsSelected">

                                <b-table-column label="Nombre" field="name" width="40%" v-slot="props">
                                    {{ props.row.name }}
                                </b-table-column>

                                <b-table-column label="RUT" field="rut" width="20%" v-slot="props">
                                    {{ props.row.rut }}
                                </b-table-column>

                                <b-table-column label="Unidad" field="unit_name" width="40%" v-slot="props">
                                    {{ props.row.unit_name }}
                                </b-table-column>

                                <template slot="empty" slot-scope="props">
                                    <div class="columns is-centered">
                                        <div class="column is-6 is-centered has-text-centered">
                                            <b-message type="is-warning">
                                                No se han encontrado Académicos/as.
                                            </b-message>
                                        </div>
                                    </div>
                                </template>
                            </b-table>

                            <div class="columns">
                                <div class="column has-text-right">
                                    <b-button v-if="activeFilter" label="Seleccionar Academicos/as"
                                        type="is-success" icon-left="check"
                                        @click="validateSelectedAcademics" />
                                </div>
                            </div>
                        </form>
                    </div>

                    <div v-else>
                        <div class="title is-5">
                            Datos de el/la Académico/a
                            <hr class="dropdown-divider" aria-role="menuitem">
                        </div>

                        <div v-for="(academic, i) in academicsSelected" :key="i" class="columns">
                            <div class="column content">
                                <h6>Unidad:</h6>
                                <p>{{ academic.unit_name }}</p>
                            </div>

                            <div class="column content">
                                <h6>Nombre:</h6>
                                <p>{{ academic.name }}</p>
                            </div>

                            <div class="column content">
                                <h6>RUT:</h6>
                                <p>{{ academic.rut }}</p>
                            </div>
                        </div>

                        <div class="columns">
                            <div class="column has-text-right">
                                <b-button type="is-blue-color" label="Buscar otro/a Académico/a" icon-left="search"
                                    @click="isSelectedAcademic = false; academicsSelected = []" />
                            </div>
                        </div>

                        <div class="title is-5">
                            Fechas de Ampliación
                            <hr class="dropdown-divider" aria-role="menuitem">
                        </div>

                        <form @submit.prevent="handleSubmit(saveExtendPhaseTerm)">
                            <div class="columns mb-6">
                                <div class="column">
                                    <b-field label="Fecha de Inicio *">
                                        <ValidationProvider name="Fecha de Inicio"
                                            :rules="{ start_date_before_end_date: endDate, required: true }"
                                            v-slot="{ errors }">
                                            <b-datepicker v-model="startDate" icon="calendar-alt" trap-focus
                                                locale="es-ES" editable placeholder="dd/mm/aaaa" />
                                            <span class="validation-alert">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </b-field>
                                </div>

                                <div class="column">

                                    <b-field label="Fecha de Término *">
                                        <ValidationProvider name="Fecha de Término"
                                            :rules="{ end_date_not_before_start_date: startDate, required: true }"
                                            v-slot="{ errors }">
                                            <b-datepicker v-model="endDate" icon="calendar-alt" trap-focus
                                                locale="es-ES" editable placeholder="dd/mm/aaaa" />
                                            <span class="validation-alert">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </b-field>
                                </div>
                            </div>

                            <br>
                            <br>
                        </form>
                    </div>

                    <b-loading is-full-page v-model="isLoading" />
                </section>
            </div>
            <footer class="modal-card-foot is-flex is-justify-content-space-between">
                <b-button label="Cerrar" @click="$emit('close')" />
                <b-button v-if="isSelectedAcademic" label="Ampliar Plazo de Declaración" type="is-purple-color-usach"
                    icon-left="users-cog" @click="confirmSaveExtendPhaseTerm()" />
            </footer>
        </ValidationObserver>
    </section>
</template>

<script>
import axios from 'axios';
export default {

    name: 'ModalNewExtendPhaseTermAcademics',

    props: {
        performancePhaseId: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            isLoading: false,
            isSelectedAcademic: false,
            academicsSelected: [],
            activeFilter: false,

            startDate: null,
            endDate: null,

            units: [],
            academics: [],

            // Filter
            filter: {
                rut: null,
                dv: null,
                unit_id: null,
                name: null,
                last_name: null,
                second_surname: null,
            },
        }
    },

    async created() {
        await this.getUnits()
    },

    methods: {
        async getUnits() {
            this.isLoading = true;
            await axios
                .get('/units/get-departments-of-engineering-faculty.json')
                .then(response => {
                    this.units = response.data;
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al traer la información. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        async filterAcademics() {
            this.isLoading = true;
            await axios
                .get('/people/academics-by-filters.json', {
                    params: {
                        rut: this.filter.rut,
                        dv: this.filter.dv,
                        unit_id: this.filter.unit_id,
                        name: this.filter.name,
                        last_name: this.filter.last_name,
                        second_surname: this.filter.second_surname,
                    }
                })
                .then(response => {
                    this.academics = response.data;
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al traer la información del filtro. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        validateSelectedAcademics() {

            if (this.academicsSelected.length === 0) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Debe seleccionar al menos un/a Académico/a para ampliar el Plazo de Declaración.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return;
            }

            this.isSelectedAcademic = true
        },

        async confirmSaveExtendPhaseTerm() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Existe un error en uno de los campos, favor de revisar.',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return;
            }

            this.$buefy.dialog.confirm({
                title: 'Agregar Ampliación',
                message: `¿Está seguro de agregar la Ampliación de Plazo de Declaración de los/las Académicos/as?`,
                confirmText: 'Sí',
                type: 'is-warning',
                hasIcon: true,
                icon: 'exclamation-triangle',
                iconPack: 'fa',
                ariaRole: 'alertdialog',
                ariaModal: true,
                onConfirm: async () => {
                    await this.saveExtendPhaseTerm();
                }
            })
        },

        async saveExtendPhaseTerm() {
            this.isLoading = true
            this.academicsSelected.forEach(academic => {
                academic.is_unit = false;
                academic.performance_phase_id = this.performancePhaseId;
                academic.id_object = academic.id;
                academic.start_date = this.startDate;
                academic.end_date = this.endDate;
            })
            await axios
                .post('/extend_phase_terms.json', {
                    is_unit: false,
                    extend_academics: this.academicsSelected,
                })
                .then(response => {
                    this.$buefy.dialog.alert({
                        title: 'Éxito',
                        message: `Se amplió el Plazo de Declaración de los/as Académicos/as seleccionados.`,
                        type: 'is-success',
                        hasIcon: true,
                        icon: 'check-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                    this.$emit('refresh');
                    this.$emit('close');
                })
                .catch(error => {
                    let msg = error.response.data.errors ? error.response.data.errors : 'Hubo un error al ampliar el Plazo de Declaración. Intente más tarde';
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: msg,
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    }
}
</script>